export default "__VITE_ASSET__DffPCWNq__"